import React from "react";
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { ClientNotificationSubscriptionForm } from "../Form/Form";


export const ClientNotificationSubscriptionCreate = (props) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<ClientNotificationSubscriptionForm />
		</SimpleForm>
	</Create>
);
